import type { DuAnCongViecTree } from '@/types/action-plan/DuAnView';
import type { DataNode } from 'antd/es/tree';

// #region tree

/** Việc lá (không có con) trong forest. */
export const flattenLeafTasks = (trees: DuAnCongViecTree[]): DuAnCongViecTree[] => {
  const leaves: DuAnCongViecTree[] = [];
  const visit = (node: DuAnCongViecTree) => {
    if (node.childs?.length) {
      node.childs.forEach(visit);
      return;
    }
    leaves.push(node);
  };
  trees.forEach(visit);
  return leaves;
};

/** Mọi node của forest (cha trước con, theo thứ tự hiển thị). */
export const flattenAllNodes = <T extends { childs?: unknown[] | null }>(items: T[]): T[] => {
  const out: T[] = [];
  const walk = (list: T[]) => {
    list.forEach((node) => {
      out.push(node);
      if (node.childs && node.childs.length > 0) walk(node.childs as T[]);
    });
  };
  walk(items);
  return out;
};

// #endregion tree

// #region pathTree

/** Tách chuỗi đường dẫn dạng breadcrumb thành các cấp. */
export const PATH_SEGMENT_SEPARATOR = /\s*[>›|]\s*|\s*\/\s*/;

export type PathTreeItem = {
  id?: string;
  ten?: string;
};

export function splitPathLabel(label: string): string[] {
  return String(label || '')
    .split(PATH_SEGMENT_SEPARATOR)
    .map((part) => part.trim())
    .filter(Boolean);
}

function buildNestedLinearTree(labels: string[], keys: string[]): DataNode[] {
  if (!labels.length) return [];

  const build = (index: number): DataNode => ({
    key: keys[index] || `path-${index}`,
    title: labels[index],
    children: index < labels.length - 1 ? [build(index + 1)] : undefined,
  });

  return [build(0)];
}

export function buildLinearPathTreeFromLabels(labels: string[]): DataNode[] {
  const normalized = labels.map((label) => String(label || '').trim()).filter(Boolean);
  if (!normalized.length) return [];
  return buildNestedLinearTree(
    normalized,
    normalized.map((_, index) => `path-${index}`),
  );
}

export function buildLinearPathTreeFromItems(items: PathTreeItem[]): DataNode[] {
  const labels = items
    .map((item, index) => String(item.ten ?? item.id ?? `node-${index}`).trim())
    .filter(Boolean);
  if (!labels.length) return [];

  const keys = items.map((item, index) => String(item.id || `path-${index}`));
  return buildNestedLinearTree(labels, keys);
}

// #endregion pathTree
